
import { atom } from "recoil";

const backTimeState =atom({
    key: 'backTime',
    default: 'no'
})

export default backTimeState